import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { useModules } from '../../lib/useModules';

// Orden de preferencia al entrar, por rol. Se toma el primero cuyo módulo esté
// habilitado, para que un tenant sin (por ejemplo) Contactos no aterrice en una
// pantalla de "módulo no disponible" apenas inicia sesión.
const LANDING_PREFERENCES = {
    agent: [
        { path: '/my-portfolio', module: 'portfolio' },
        { path: '/leads', module: 'leads' },
        { path: '/contacts', module: 'contacts' },
        { path: '/chat', module: 'chat' },
        { path: '/deals', module: 'deals' },
    ],
    default: [
        { path: '/contacts', module: 'contacts' },
        { path: '/manager', module: 'dashboard' },
        { path: '/leads', module: 'leads' },
        { path: '/chat', module: 'chat' },
        { path: '/deals', module: 'deals' },
    ],
};

export default function LandingRedirect() {
    const role = useAuthStore(state => state.user?.role);
    const { isModuleEnabled } = useModules();

    if (role === 'super_admin') {
        return <Navigate to="/super-admin/tenants" replace />;
    }

    const candidates = LANDING_PREFERENCES[role] ?? LANDING_PREFERENCES.default;
    const target = candidates.find(c => isModuleEnabled(c.module));

    // Si no quedó ningún módulo de navegación habilitado, Configuración sigue
    // siendo accesible (es la pantalla de cuenta, nunca se restringe).
    return <Navigate to={target?.path ?? '/settings'} replace />;
}
